import {
	getSignedUrl,
	downloadFileAndShowInTab,
	downloadZip,
	downloadFileBlob, uploadFileToS3, ACCEPTED_FORMATS,
} from "./FilesAndS3Utils";
import ActionButtonComponent from "@ui-components/ActionButtonComponent";
import ArrowDownTrayIcon from "@heroicons/react/24/solid/ArrowDownTrayIcon";
import {PencilSquareIcon} from "@heroicons/react/24/solid";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import {ArrowUpTrayIcon} from "@heroicons/react/24/solid";
import TrashIcon from "@heroicons/react/24/solid/TrashIcon";
import {maxSize} from "./constants";
import {EyeIcon} from "@heroicons/react/20/solid";

export const buildUsersDocuments = (
	worksiteId,
	userLoadedDocuments,
	setUserLoadedDocuments,
	setShowDeleteUserDocumentsDialog,
	intl,
	setShowEditGroup,
	setShowEditDocument,
	apiRequest,
	push,
	country,
) => {

	const prepareAndDownloadZip = async (docs) => {
		const promises = docs.filter(document=>document.s3_url !== "").map(async (document) => {
			let blob = null
			let filename = null
			const signed_url = await getSignedUrl(apiRequest, document.s3_url, document.name, 'worksite_images');
			blob = await downloadFileBlob(signed_url);
			filename = document.name
			return {filename, blob}
		})
		await downloadZip(intl.formatMessage({id: 'users_documents'}), await Promise.all(promises))
	}

	const buildDocumentInfo = async (document) => {
		let dateWithoutOffset
		const isoStr = document['created_at'];
		const date = new Date(isoStr);
		const offset = date.getTimezoneOffset() * 60 * 1000;
		const timestampWithOffset = date.getTime();
		const timestampWithoutOffset = timestampWithOffset - offset;
		dateWithoutOffset = new Date(timestampWithoutOffset);
		return `${intl.formatMessage({id: "created_on"})}
		${intl.formatDate(dateWithoutOffset, {day: "numeric", month: "long", year: "numeric"})}
		${intl.formatMessage({id: "at"})} ${intl.formatTime(dateWithoutOffset)}
		${intl.formatMessage({id: "by"})} ${document.des_author}`
	}

	return {
		title: intl.formatMessage({id:"users_documents"}),
		alternateColor: "bg-ivory",
		groups: userLoadedDocuments?.map(group => {
			return {
				key: "users_documents_content",
				id: group.id,
				title: group.name,
				val_order: group.val_order,
				flg_public: group.flg_public,
				lst_visibility: group.lst_visibility,
				cod_author: group.cod_author,
				flg_internal_author: group.flg_internal_author,
				documents: group.documents.map(document => {
					return {
						...document,
						onDocumentClicked: [null,undefined,""].includes(document.s3_url)?null:
							async () => {
							const signed_url = await getSignedUrl(apiRequest, document.s3_url, document.name, 'worksite_images');
							await downloadFileAndShowInTab(signed_url, document.name);
						},
						visible: true,
						info: buildDocumentInfo(document),
					}
				}),
				groupActions: {
					// edit group
					'edit': {
						actionComponent: () => <div>
							<PencilSquareIcon
								className="h-6 w-6 cursor-pointer hover:text-gray-500"
								onClick={() => {
									setShowEditGroup(group);
								}
								}
							/>
						</div>
					},
					'upload': {
						actionComponent: () => <ActionButtonComponent
							icon={ArrowUpTrayIcon}
							action={async (setLoading) => {
								const fileLoader = document.createElement('input')
								fileLoader.type = 'file'
								fileLoader.multiple = true
								fileLoader.className = 'hidden'
								fileLoader.accept = ACCEPTED_FORMATS.join(", ")
								fileLoader.onchange = async (e) => {
									setLoading(true)
									let newList = [];
									let size = 0;
									Object.keys(e.target.files).forEach((key) => {
										newList.push(e.target.files[key]);
										size += e.target.files[key].size;
									});
									if (size > maxSize) {
										push({type: 'error', title: intl.formatMessage({id: 'size_limit_exceeded'})});
									} else {
										const filesUploaded = await Promise.all(newList.map(async (file) => {
											try {
												const url = await uploadFileToS3(
													apiRequest,
													file,
													`documents/${country.code}/${group.id_worksite}`,
													'documents',
												);
												return {
													name: file.name,
													size: file.size,
													s3_url: url,
												}
											} catch (e) {
												push({type: 'error', title: intl.formatMessage({id: 'server_error'})});
											}
										}));
										// add files calling post to backend
										for (let file of filesUploaded.filter(f => f)) {
											await apiRequest.post(`/worksite_documents/document`, {
												id_group: group.id,
												name: file.name,
												s3_url: file.s3_url,
												val_size: file.size,
												lst_visibility: group.lst_visibility,
												flg_public: group.flg_public,
											})
										}
									}
									const newUserLoadedDocuments = await apiRequest.get(`/worksite_documents/${group.id_worksite}`);
									setUserLoadedDocuments(newUserLoadedDocuments);
									setLoading(false)
								}
								fileLoader.click()
							}}
							text={intl.formatMessage({id: "upload_documents"})}
							styleType={"white"}
						/>
					}
				}
			}
		}),
		actions: {
			download:	{
				actionComponent: (documents, visible) => <ActionButtonComponent
					icon={ArrowDownTrayIcon}
					action={async () => {
						await prepareAndDownloadZip(documents)
					}}
				/>
			},
			addGroup: {
				actionComponent: (documents, visible) => <ActionButtonComponent
					icon={PlusIcon}
					action={() => {
						setShowEditGroup({
							new: true,
							name: "",
							documents: [],
							lst_visibility: [],
							id_worksite: worksiteId
						})
					}}
				/>
			},
			deleteDocuments: {
				actionComponent: (documents, visible) => visible?<ActionButtonComponent
					icon={TrashIcon}
					action={async () => {
						setShowDeleteUserDocumentsDialog(documents)
					}}
				/>:null
			},
			editDocumentVisibility: {
				actionComponent: (documents, visible) => visible?<ActionButtonComponent
					icon={EyeIcon}
					action={() => {
						setShowEditDocument(documents);
					}}
				/>:null
			}
		}
	}
}
